module.exports = __webpack_public_path__ + "img/Waajeed.aaf0208a.jpg";